import React from "react";
import { LayoutSetup, LayoutSetupProps } from "../LayoutSetup";
import { Banner } from "./Banner";

type Props = LayoutSetupProps;

export const LayoutPaymentsSetup: React.FC<Props> = ({ ...layoutProps }) => {
  return <LayoutSetup {...layoutProps} banner={<Banner />} />;
};
